// Library modul
import { Component } from "react";
import { connect } from "react-redux";
import shpwrite from "@mapbox/shp-write";
import { saveAs } from "file-saver";

// import dict from "../../Data/dict.json";
import { CircularProgress } from "@mui/material";
import logo_shp from "../../Assets/svg/logo_shp.svg"

// WKT .prj valid untuk EPSG:4326 (WGS84)
const WGS84_WKT =
  'GEOGCS["WGS 84",DATUM["WGS_1984",SPHEROID["WGS 84",6378137,298.257223563]],' +
  'PRIMEM["Greenwich",0],UNIT["degree",0.0174532925199433]]';

// Hanya izinkan tipe primitif untuk properti shapefile
// function sanitizeProps(src = {}) {
//   const out = {};
//   Object.keys(src || {}).forEach((k) => {
//     const v = src[k];
//     if (
//       v === null ||
//       typeof v === "string" ||
//       typeof v === "number" ||
//       typeof v === "boolean"
//     ) {
//       out[k] = v;
//     } else {
//       out[k] = v != null ? String(v) : null; // fallback
//     }
//   });
//   return out;
// }

// Potong nama field ke 10 karakter (limit .dbf)
// function trimFieldName(name = "") {
//   // hilangkan karakter yang tidak valid di DBF
//   const cleaned = String(name).replace(/[^A-Za-z0-9_]/g, "_");
//   return cleaned.slice(0, 10) || "FIELD";
// }

class downloadShp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feature_filter: [],
      loading: false,
    };
    this._isMounted = false;
  }

  componentDidMount() { this._isMounted = true; }
  componentWillUnmount() { this._isMounted = false; }
  safeSetState = (u) => this._isMounted && this.setState(u);

  on_download_shp = async () => {
    try {
      this.safeSetState({ loading: true });

      const { layer_id, geo_layer_list, sorted_by } = this.props.layer;

      let geo_layer = geo_layer_list.find((e) => e.geo_layer._id === layer_id);

      const fields = geo_layer?.geo_layer?.fields
        ? geo_layer?.geo_layer?.fields
        : [];
      let filename = geo_layer?.geo_layer?.name;

      let geo_filter = this.state.feature_filter;

      // sorting
      let field, sort;
      if (sorted_by?.length > 0) {
        field = sorted_by?.[0]?.field;
        sort = sorted_by?.[0]?.sort;

        const isFromSmall = sort === "desc" ? false : true;
        const key = field;
        geo_filter = geo_filter.sort((a, b) => {
          if (a?.properties?.[key] < b?.properties?.[key])
            return isFromSmall ? -1 : 1;
          if (a?.properties?.[key] > b?.properties?.[key])
            return isFromSmall ? 1 : -1;
          return 0;
        });
      }

      geo_layer = geo_layer?.geo_layer;
      let geojson = geo_layer?.geojson ? geo_layer.geojson_filtered : {};
      const geoJsonFilter = {
        type: "FeatureCollection",
        features: geo_filter,
      };
      let dataJson =
        geo_filter?.length === 1 || geo_filter?.length >= 1
          ? geoJsonFilter
          : geojson;

      const features = dataJson?.features?.map((item) => {
        let properties = {};

        fields
          .filter((data) => data?.isStyle !== true || data?.isStyle === undefined)
          .forEach((data) => {
            properties[data.name] = item.properties[data.key];
          });

        return {
          type: item.type,
          geometry: item.geometry,
          properties: properties,
        };
      });

      const body = {
        type: "FeatureCollection",
        features: features,
      };

      const shpOptions = {
        folder: filename, // nama folder di dalam zip
        filename: filename,
        outputType: "blob",
        compression: "DEFLATE",
        prj: WGS84_WKT,   // JANGAN pakai placeholder "..."
        types: {
          point: filename,
          polyline: filename,
          polygon: filename,
        }
      };

      // this.setState({ loading: true }, async () => {
      const zip = await shpwrite.zip(body, shpOptions); // ArrayBuffer/TypedArray
      const blob =
        zip instanceof ArrayBuffer || ArrayBuffer.isView(zip)
          ? new Blob([zip], { type: "application/zip" })
          : zip instanceof Blob
            ? zip
            : new Blob([zip], { type: "application/zip" });

      saveAs(blob, `${filename}.zip`);
      this.safeSetState({ loading: false });
      // });
    } catch (err) {
      this.safeSetState({ loading: false });
      alert(`Gagal membuat SHP: ${err?.message || err}`);
    }
  };

  render() {
    // const language = localStorage?.language ? localStorage?.language : "ina";
    // const label =
    //   dict?.["Download SHP"]?.[language]?.toUpperCase() || "DOWNLOAD SHP";

    const { loading } = this.state;

    return (
      <button
        onClick={this.on_download_shp}
        data-mapid="clickDownloadGeoJson"
        title={this.state.loading ? "Menyiapkan file…" : "UNDUH SHP"}
        className="button_download_data"
      >
        {loading ?
        (<CircularProgress size={20} thickness={8} sx={{ color: "black" }} />)
        :
        (<img src={logo_shp} width={40} alt="icon download shp" />)
        }
        <p className="layer_action_label inactive_label">SHP</p>
      </button>
    );
  }
}

const mapStateToProps = (state) => ({
  map: state.map,
  auth: state.auth,
  layer: state.layer,
});

export default connect(mapStateToProps, {})(downloadShp);
